import { Info, AlertTriangle, AlertCircle, CheckCircle, X } from 'lucide-react'

interface AlertBannerProps {
  type: 'info' | 'warning' | 'error' | 'success'
  message: string
  onDismiss?: () => void
}

const config = {
  info: { bg: 'bg-brand-blue/20 border-brand-blue/30', text: 'text-blue-200', Icon: Info },
  warning: { bg: 'bg-gold/20 border-gold/30', text: 'text-gold', Icon: AlertTriangle },
  error: { bg: 'bg-red-alert/20 border-red-alert/30', text: 'text-red-300', Icon: AlertCircle },
  success: { bg: 'bg-green-positive/20 border-green-positive/30', text: 'text-green-300', Icon: CheckCircle },
} as const

export default function AlertBanner({ type, message, onDismiss }: AlertBannerProps) {
  const { bg, text, Icon } = config[type]

  return (
    <div className={`flex items-center gap-3 px-4 py-3 rounded-xl border ${bg} ${text}`}>
      <Icon size={18} className="shrink-0" />
      <span className="flex-1 text-sm">{message}</span>
      {onDismiss && (
        <button onClick={onDismiss} className="shrink-0 hover:opacity-70 transition-opacity">
          <X size={16} />
        </button>
      )}
    </div>
  )
}
